import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Heart, Target, CalendarCheck } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <CalendarCheck className="w-8 h-8 text-brand-accent" data-id="element-11" />,
    title: 'Ahorrá +10 horas semanales',
    desc: 'Olvidate de buscar ejercicios en YouTube. Tenés todo organizado y listo para aplicar.'
  }, {
    icon: <Zap className="w-8 h-8 text-brand-accent" data-id="element-12" />,
    title: 'Clases 100% Dinámicas',
    desc: 'Ejercicios probados que mantienen a los chicos en movimiento y divirtiéndose.'
  }, {
    icon: <Heart className="w-8 h-8 text-brand-accent" data-id="element-13" />,
    title: 'Alumnos Motivados',
    desc: 'Notarás cómo esperan con ansias tu próxima clase gracias a las dinámicas innovadoras.'
  }, {
    icon: <Target className="w-8 h-8 text-brand-accent" data-id="element-14" />,
    title: 'Organización Total',
    desc: 'Progresión lógica de enseñanza para que veas resultados reales en la técnica de tus alumnos.'
  }];
  return <section className="py-20 px-4 bg-brand-dark border-y border-white/5" data-id="element-15">
      <div className="max-w-6xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-4xl md:text-5xl font-display text-brand-cream mb-4 uppercase" data-id="element-18">
            Lo que vas a <span className="accent-underline" data-id="element-19">lograr</span> con
            esta guía
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-20">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-card p-6 rounded-2xl border border-white/5 hover:border-brand-accent/40 transition-colors" data-id="element-21">
              <div className="bg-brand-accent/10 border border-brand-accent/30 w-14 h-14 rounded-full flex items-center justify-center mb-4" data-id="element-22">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-display text-brand-cream mb-2 tracking-wide" data-id="element-23">
                {benefit.title}
              </h3>
              <p className="text-brand-cream/70 text-sm font-medium" data-id="element-24">
                {benefit.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}